/**
 * 施術カテゴリのルーティング定義。
 * ナビゲーション・メガメニュー・フッター・QUICK NAV から共通で参照する。
 */
export const treatmentRoutes = {
  hairRemoval: "/treatment/hair-removal",
  slimZero: "/treatment/slim-zero",
  skinManagement: "/treatment/skin-management",
  regenerative: "/treatment/regenerative",
  injectables: "/treatment/injectables",
  eye: "/treatment/eye",
} as const;

export const primaryNav = [
  { label: "施術メニュー", key: "treatment", href: "#treatments" },
  { label: "お悩みから探す", key: "concern", href: "#concern" },
  { label: "料金表", href: "/price" },
  { label: "SBDCについて", href: "/#about" },
  { label: "初めての方へ", href: "/#first-visit" },
  { label: "Q&A", href: "/#faq" },
  { label: "アクセス", href: "/#access" },
];

export const treatmentMenuGroups = [
  {
    groupEn: "MAIN TREATMENTS",
    items: [
      {
        en: "MEDICAL HAIR REMOVAL",
        jp: "医療脱毛",
        href: treatmentRoutes.hairRemoval,
        links: [
          { label: "レディース", hash: "#hair-ladies" },
          { label: "メンズ", hash: "#hair-mens" },
          { label: "全身", hash: "#hair-ladies-full" },
          { label: "顔", hash: "#hair-ladies-face" },
          { label: "VIO", hash: "#hair-ladies-vio" },
          { label: "ヒゲ", hash: "#hair-mens-beard" },
          { label: "部位別", hash: "#hair-mens-body" },
        ],
      },
      {
        en: "MEDICAL SLIM ZERO",
        jp: "医療痩身・ダイエット",
        href: treatmentRoutes.slimZero,
        links: [
          { label: "新脂肪溶解注射", hash: "#slim-injection" },
          { label: "RF（ラジオ波）", hash: "#slim-rf" },
          { label: "脂肪冷却", hash: "#slim-cool" },
          { label: "医療用EMS", hash: "#slim-ems" },
        ],
      },
      {
        en: "SKIN MANAGEMENT",
        jp: "お肌管理",
        href: treatmentRoutes.skinManagement,
        links: [
          { label: "ニキビ", hash: "#skin-acne" },
          { label: "シミ", hash: "#skin-pigment" },
          { label: "毛穴", hash: "#skin-pores" },
          { label: "たるみ・シワ", hash: "#skin-lifting" },
          { label: "肌質改善", hash: "#skin-texture" },
          { label: "ハリ・ツヤ", hash: "#skin-glow" },
        ],
      },
    ],
  },
  {
    groupEn: "SPECIAL TREATMENTS",
    items: [
      {
        en: "REGENERATIVE MEDICINE",
        jp: "再生医療",
        href: treatmentRoutes.regenerative,
        links: [
          { label: "StemSup点滴", hash: "#reg-stemsup-drip" },
          { label: "幹細胞培養上清液 StemSup", hash: "#culture-supernatant" },
        ],
      },
      {
        en: "INJECTABLES",
        jp: "注入治療",
        href: treatmentRoutes.injectables,
        links: [
          { label: "ボトックス", hash: "#inj-botox" },
          { label: "ヒアルロン酸", hash: "#inj-ha" },
        ],
      },
      {
        en: "EYE TREATMENT",
        jp: "二重・目元",
        href: treatmentRoutes.eye,
        links: [{ label: "二重埋没法", hash: "#eye-double" }],
      },
    ],
  },
];

export const concernMenuGroups = [
  {
    groupEn: "FACE / SKIN",
    href: treatmentRoutes.skinManagement,
    items: [
      { label: "ニキビ", hash: "#skin-acne" },
      { label: "シミ", hash: "#skin-pigment" },
      { label: "くすみ", hash: "#skin-pigment" },
      { label: "毛穴", hash: "#skin-pores" },
      { label: "たるみ", hash: "#skin-lifting" },
      { label: "シワ", hash: "#skin-lifting" },
      { label: "ハリ・ツヤ", hash: "#skin-glow" },
      { label: "肌質改善", hash: "#skin-texture" },
    ],
  },
  {
    groupEn: "CONTOUR / FACE",
    href: treatmentRoutes.injectables,
    items: [
      { label: "エラ", hash: "#inj-botox-masseter" },
      { label: "顎", hash: "#inj-ha-chin" },
      { label: "ほうれい線", hash: "#inj-ha-nasolabial" },
      { label: "額", hash: "#inj-botox-forehead" },
      { label: "こめかみ", hash: "#inj-ha-temple" },
      { label: "涙袋", hash: "#inj-ha-tear" },
      { label: "唇", hash: "#inj-ha-lip" },
    ],
  },
  {
    groupEn: "BODY",
    href: treatmentRoutes.slimZero,
    items: [
      { label: "痩せたい", hash: "#slim-injection" },
      { label: "部分痩せ", hash: "#slim-injection" },
      { label: "お腹", hash: "#slim-cool" },
      { label: "二の腕", hash: "#slim-rf" },
      { label: "太もも", hash: "#slim-cool" },
      { label: "肩", hash: "#slim-ems" },
      { label: "ふくらはぎ", hash: "#slim-rf" },
    ],
  },
  {
    groupEn: "HAIR REMOVAL",
    href: treatmentRoutes.hairRemoval,
    items: [
      { label: "全身", hash: "#hair-ladies-full" },
      { label: "顔", hash: "#hair-ladies-face" },
      { label: "ヒゲ", hash: "#hair-mens-beard" },
      { label: "ワキ", hash: "#hair-mens-body" },
      { label: "VIO", hash: "#hair-ladies-vio" },
    ],
  },
  {
    groupEn: "EYES",
    href: treatmentRoutes.eye,
    items: [
      { label: "二重にしたい", hash: "#eye-double" },
      { label: "目元を整えたい", hash: "#eye-double" },
    ],
  },
];

export const footerGroups = [
  {
    title: "TREATMENT",
    links: [
      { label: "医療脱毛", href: treatmentRoutes.hairRemoval },
      { label: "医療痩身", href: treatmentRoutes.slimZero },
      { label: "お肌管理", href: treatmentRoutes.skinManagement },
      { label: "再生医療", href: treatmentRoutes.regenerative },
      { label: "注入治療", href: treatmentRoutes.injectables },
      { label: "二重・目元", href: treatmentRoutes.eye },
    ],
  },
  {
    title: "GUIDE",
    links: [
      { label: "SBDCについて", href: "/#about" },
      { label: "料金表", href: "/price" },
      { label: "初めての方へ", href: "/#first-visit" },
      { label: "Q&A", href: "/#faq" },
      { label: "アクセス", href: "/#access" },
    ],
  },
  {
    title: "OTHER",
    links: [
      // SBDC公式Instagram（正式URL）
      { label: "Instagram", href: "https://www.instagram.com/shibuya.beauty.clinic/" },
      { label: "プライバシーポリシー", href: "/privacy" },
      { label: "未成年者同意書", href: "/minor-consent" },
      { label: "医療広告に関する表記", href: "/medical-advertising" },
      { label: "採用情報", href: "/recruit" },
    ],
  },
];

export const mobileMenuLinks = [
  { label: "お悩みから探す", href: "/#concern" },
  { label: "料金表", href: "/price" },
  { label: "SBDCについて", href: "/#about" },
  { label: "初めての方へ", href: "/#first-visit" },
  { label: "Q&A", href: "/#faq" },
  { label: "アクセス", href: "/#access" },
  // SBDC公式Instagram（正式URL）
  { label: "Instagram", href: "https://www.instagram.com/shibuya.beauty.clinic/" },
];

export const mobileTreatmentLinks = [
  { label: "医療脱毛", href: treatmentRoutes.hairRemoval },
  { label: "医療痩身", href: treatmentRoutes.slimZero },
  { label: "お肌管理", href: treatmentRoutes.skinManagement },
  { label: "再生医療", href: treatmentRoutes.regenerative },
  { label: "注入治療", href: treatmentRoutes.injectables },
  { label: "二重・目元", href: treatmentRoutes.eye },
];